module.exports = "<div class=\"inp-spatial inp-text\" @click=start> {{model ? 'Wijzigen...' : 'Selecteren...'}} <div class=inp-spatial-fixed v-show=showMap transition=opacify> <div class=inp-spatial-cancel>Annuleren</div> <div class=inp-spatial-map @click.stop></div> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputSpatial.vue
 ** module id = 138
 ** module chunks = 0
 **/